import React, { useEffect } from "react";
import * as S from "./OfferBanner.styles";
import Icon from "../../../../core-components/IconsSelector";
import useCarousel from "../../../../../shared/containers/useCarousel/useCarousel";
import { CTA_TYPE, getActionNameForOmniture } from "../../../../../shared/utils/omni-utils";
import { gcHomeScreen, getLoadedComponent, pushCtaOmniEvents } from "../../../../../shared/config/omni";
import { OFFER_CAROUSEL_INCREMENT_CLICK, CABS_LANDING_ROUTE, OFFER_CAROUSEL_DECREMENT_CLICK, OFFERS_BANNER } from "../../../../../shared/utils/util-constants";
interface OffersDataProps {
  offersData: Array<IOfferState>;
}
export interface IOfferState {
  url?: string;
  img_url?: string;
  sub_heading?: string;
  validity_text?: string;
  slug?: string;
}

const OfferBanner: React.FC<OffersDataProps> = ({ offersData }) => {
  if (!offersData?.length) return <S.HomeCaroSliderWrap></S.HomeCaroSliderWrap>;
  const {
    dataList,
    increment,
    decrement,
    isLeftCursorActive,
    isRightCursorActive,
  } = useCarousel(offersData, 2);

  useEffect(() => {
    getLoadedComponent('OfferBanner')
  }, [])

  const onOfferClick = (url, slug) => {
    pushCtaOmniEvents(getActionNameForOmniture(gcHomeScreen, `home_offer_${slug}`), CTA_TYPE.IMAGES, OFFERS_BANNER, url)
    window.open(url, '_blank')
  }

  return (
    <S.HomeCaroSliderWrap>
      <S.HomeCaroSliderInnerWrap>
        {dataList?.map(
          ({ url, img_url, sub_heading, validity_text, slug }, index) => (
            <li key={index} onClick={() => onOfferClick(url, slug)}>
              {img_url ? <S.SliderImg src={img_url} alt="offer" /> : null}
              <S.SliderInfoWrap>
                {sub_heading ? (
                  <S.SliderHeadInfoText>{sub_heading}</S.SliderHeadInfoText>
                ) : null}
                {validity_text ? (
                  <S.SliderInfoSubText>{validity_text}</S.SliderInfoSubText>
                ) : null}
              </S.SliderInfoWrap>
            </li>
          )
        ) || null}
      </S.HomeCaroSliderInnerWrap>
      {isRightCursorActive ? (
        <S.SliderArrow
          className="right"
          onClick={() => {
            pushCtaOmniEvents(getActionNameForOmniture(gcHomeScreen, OFFER_CAROUSEL_INCREMENT_CLICK), CTA_TYPE.IMAGES, OFFERS_BANNER, CABS_LANDING_ROUTE)
            increment();
          }}
          aria-label="Next Offer"
        >
          <Icon name="ArrowRightIcon" styleProps={{ fill: "#2276e3" }} />
        </S.SliderArrow>
      ) : null}
      {isLeftCursorActive ? (
        <S.SliderArrow
          className="left"
          onClick={() => {
            pushCtaOmniEvents(getActionNameForOmniture(gcHomeScreen, OFFER_CAROUSEL_DECREMENT_CLICK), CTA_TYPE.IMAGES, OFFERS_BANNER, CABS_LANDING_ROUTE)
            decrement();
          }}
          aria-label="Previous Offer"
        >
          <Icon name="ArrowLeftIcon" styleProps={{ fill: "#2276e3" }} />
        </S.SliderArrow>
      ) : null}
    </S.HomeCaroSliderWrap>
  );
};
export default OfferBanner;
